const offerDetailEl = document.querySelector('.offer-detail');

if (offerDetailEl) {
    const price = Number(offerDetailEl.dataset.price);
    const id = offerDetailEl.dataset.id;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
            value: price,
            items: [
                {
                    id: id,
                    google_business_vertical: 'custom',
                },
            ],
        },
    });
}
